import StyledContainer from "style/styledContainer"
import styled, { useTheme } from "styled-components"
import { NumericFormat, OnValueChange } from "react-number-format";
import { Column, Row } from "style/preset";
import { motion } from "framer-motion";

import { ReactComponent as BalanceSvg } from 'assets/svgs/balance.svg'

import cardOneLeft from "assets/images/light_spot_right.png";
import cardOneRight from "assets/images/light_spot_right.png";
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks";
import { setFromAmount } from "hooks/redux/slices/coreInfoSlice";
import useUtils from "hooks/useUtils";
import { useState } from "react";
import { setWalletWinOpened } from "hooks/redux/slices/walletSlice";

const PayNumberCom = () => {
    const theme = useTheme()
    const [isFocus, setIsFocus] = useState(false)
    const { loading } = useAppSelector((state) => state.app)
    const { fromToken: tokenDetail, fromAmount: amount, balanceEvm } = useAppSelector((state) => state.coreInfo)
    const dispatch = useAppDispatch()
    const { balanceEnough, isConnectedEvm, setMaxBalance } = useUtils()


    const fnFocus = () => {
      setIsFocus(true)
    }

    const fnBlur = () => {
      setIsFocus(false)
    }

    /**
     * 修改值
     */
    const onValueChange: OnValueChange = ({value}) => {
      dispatch(setFromAmount(value))
    }

    return <PayNumberWrap>
        <AnimateImgLeftWrap
          src={cardOneLeft}
          animate={{
            bottom: ["-20px", "10px", "-20px"],
            left: ["0px", "10px", "0px"],
          }}
          transition={{
            duration: 6,
            ease: "easeInOut",
            repeat: Infinity,
          }}
        ></AnimateImgLeftWrap>
        <AnimateImgRightWrap
          src={cardOneRight}
          animate={{
            right: ["-20px", "0px", "-20px"],
            top: ["0px", "10px", "0px"],
          }}
          transition={{
            duration: 6,
            ease: "easeInOut",
            repeat: Infinity,
          }}
        ></AnimateImgRightWrap>
        <PayNumberContentWrap $isFocus={isFocus}>
            <TopWrap>
                <Row $mb="10px" $justifyContent="space-between">
                    <StyledContainer $fontSize="14px" $lineHeight="16px">You will pay</StyledContainer>
                    {
                      isConnectedEvm && <MaxBtnWrap $roobertRegular onClick={setMaxBalance}>Max</MaxBtnWrap>
                    }
                </Row>
                <Row $justifyContent="space-between">
                    <NumberInput placeholder="0.00" disabled={loading} value={amount} valueIsNumericString={true} thousandSeparator="," onFocus={fnFocus} onBlur={fnBlur} onValueChange={onValueChange}></NumberInput>

                    <Column $alignItems="flex-end" $ml="10px">
                        <StyledContainer $fontSize="16px" $lineHeight="18px">{tokenDetail?.symbol}</StyledContainer>
                        <StyledContainer $mt="2px" $fontSize="12px" $lineHeight="14px" $roobertRegular $nowrap>{tokenDetail?.name}</StyledContainer>
                    </Column>
                </Row>
            </TopWrap>
            <BottomWrap $justifyContent="space-between">
                <Row>
                    <BalanceSvgWrap></BalanceSvgWrap>
                    <StyledContainer $ml="6px" $fontSize="12px" $lineHeight="14px" $color={theme.lightBlack} $roobertRegular>Balance</StyledContainer>
                </Row>
                {
                  isConnectedEvm ? <Row>
                    {
                      balanceEnough ? <StyledContainer $height="20px"></StyledContainer> : <ErrorInfoWrap $mr="8px">Your balance is not enough</ErrorInfoWrap>
                    }
                    <StyledContainer $fontSize="12px" $lineHeight="14px" $color={balanceEnough ? theme.lightBlack : '#C31D28'}>{balanceEvm} {tokenDetail?.symbol}</StyledContainer>
                  </Row> : <WarningInfoWrap $roobertRegular onClick={() => dispatch(setWalletWinOpened(true))}>Connect your wallet to see its balance</WarningInfoWrap>
                }
            </BottomWrap>
        </PayNumberContentWrap>
    </PayNumberWrap>
}

const baseInputStyle = `
    width: 100%;
    height: 30px;
    background-color: transparent;
    border: none;
    font-family: RoobertSemiBold;
    font-size: 30px;
    font-weight: 600;
    line-height: 1;
    box-sizing: border-box;
    &:focus {
        outline: none;
    }
`;

const PayNumberWrap = styled(StyledContainer)`
    width: 100%;
    position: relative;
`

const ImgLeftWrap = styled.img`
  position: absolute;
  width: 106px;
  height: 109px;
  bottom: -20px;
  left: 0;
  transform: rotate(-330deg);
`;

const AnimateImgLeftWrap = styled(motion(ImgLeftWrap))``;

const ImgRightWrap = styled.img`
  position: absolute;
  width: 74px;
  height: 80px;
  top: 0;
  right: -10px;
`;
const AnimateImgRightWrap = styled(motion(ImgRightWrap))``;

const PayNumberContentWrap = styled(StyledContainer)<{$isFocus: boolean}>`
    background-color: ${({ theme }) => theme.basicWhite};
    position: relative;
    z-index: 1;
    border-radius: 9px;
    box-shadow: ${({$isFocus}) => $isFocus ? '0px 14px 64px -4px rgba(24, 39, 75, 0.12), 0px 8px 22px -6px rgba(24, 39, 75, 0.12) !important' : '0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08)'};
    &:hover {
      box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    }
`
const TopWrap = styled(StyledContainer)`
    padding: 20px 20px 16px 20px;
`

export const NumberInput = styled(NumericFormat)`
  ${baseInputStyle}
  color: ${({theme}) => theme.basicBlack};
  &:focus {
    outline: none;
    color:  ${({theme}) => theme.basicBlack};
  }
  &::placeholder {
    color: #CACCCE;
  }
`;

const BottomWrap = styled(Row)`
  border-top: 1px solid #F2F2F2;
  padding: 16px 20px;
`

const BalanceSvgWrap = styled(BalanceSvg)`
  width: 16px;
  height: 16px;
`

const MaxBtnWrap = styled(StyledContainer)`
  font-size: 12px;
  line-height: 1;
  color: ${({theme}) => theme.basicPurple};
  cursor: pointer;
`

const WarningInfoWrap = styled(StyledContainer)`
  font-size: 12px;
  line-height: 14px;
  background-color: #FDFDD8;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 4px;
`

const ErrorInfoWrap = styled(WarningInfoWrap)`
  background-color: #FFF3F4;
  cursor: none;
  color: #C31D28;
  cursor: default;
`

export default PayNumberCom